export interface Range {
  start: number
  end: number
}

export interface RangeWithY extends Range {
  y: number
}
